<div class="modal-content">
  <div class="modal-body text-center">
    <div class="pb-4">
      <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    </div>
    <jhi-bary-icon *ngIf="icon" [icon]="icon" [faDirective]="FAS" size="4x" [class]="class"></jhi-bary-icon>
    <p class="lead pt-2">{{ message }}</p>
  </div>
  <div class="modal-footer justify-content-center">
    <jhi-bary-button class="mr-3" *ngIf="buttons.second" [outline]="true" color="primary" [label]="buttons.second" (clickEvent)="handleClick({ second: true })"></jhi-bary-button>
    <jhi-bary-button
      data-id-cypress="confirm"
      (clickEvent)="handleClick({ first: true })"
      *ngIf="buttons.first"
      [block]="!buttons.first"
      [label]="buttons.first"
      color="primary"
    ></jhi-bary-button>
  </div>
</div>
